import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { environment } from "src/environments/environment";

import { WindowRef } from "../common/global-refs";

@Injectable({ providedIn: "root" })
export class DataAnalyticsService {
  private pendoLoaded = false;
  private readonly renderer: Renderer2;

  constructor(
    private readonly rendererFactory: RendererFactory2,
    private readonly windowRef: WindowRef,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadAnalytics(): void {
    this.loadPendoScript();
  }

  trackPendo(event: string, properties?: Record<string, unknown>): void {
    // Pendo only records events in prod. Elsewhere the agent is absent (local)
    // or the server rejects the send (qa/dev/rt), so log instead of sending.
    if (environment.DATA_DOG_ENV !== "production") {
      const env = environment.DATA_DOG_ENV || "local";
      console.log(`[analytics:${env}:no-pendo]`, event, properties ?? {});
      return;
    }
    this.windowRef.nativeWindow.pendo?.track(event, properties);
  }

  loadPendoScript(): void {
    if (this.pendoLoaded) {
      return;
    }

    if (environment.production && environment.PENDO_KEY !== "") {
      // crossOrigin keeps Pendo's error stacks instead of "Script error."
      // (cdn.pendo.io allows CORS).
      const pendoScript = this.renderer.createElement("script");
      const PENDOKEY = environment.PENDO_KEY;
      pendoScript.type = "text/javascript";
      pendoScript.text = `
        (function(apiKey){
          (function(p,e,n,d,o){
            var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
            v=['initialize','identify','updateOptions','pageLoad','track'];
            for(w=0,x=v.length;w<x;w++)(function(m){
              o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));}
            })(v[w]);
            y=e.createElement(n);y.async=!0;y.crossOrigin='anonymous';
            y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
            z=e.getElementsByTagName(n)[0];
            z.parentNode.insertBefore(y,z);
          })(window,document,'script','pendo');
        })('${PENDOKEY}');
          `;
      this.renderer.appendChild(this.document.body, pendoScript);
      this.pendoLoaded = true;
    }
  }
}
